import React from 'react';
import PropTypes from 'prop-types';
import { Utils, translate } from 'versafleet-core';

const TaskCancelSuccessMessage = props => (
  <div className="vf-task__cancel-success-message">
    <div className="vf-task__cancel-success-message__icon">
      <i className="versa-danger" />
    </div>
    {
      Utils.TranslationHelper.replaceTag(props.strings.page.cancelSuccess, {
        count: props.count,
      })
    }
  </div>
);

TaskCancelSuccessMessage.propTypes = {
  count: PropTypes.number.isRequired,
  strings: PropTypes.shape({
    page: PropTypes.shape({
      cancelSuccess: PropTypes.string,
    }),
  }).isRequired,
};

export default translate('Task')(TaskCancelSuccessMessage);
